module.exports = __webpack_public_path__ + "d859e09525f54e1f4cfbc382879c52b1.fbx";